import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarEspacios from '../../components/espacios/SidebarEspacios';
import './EspaciosGlobal.css';

const AREA_COLORS = [
  { bg: 'rgba(59,130,246,0.12)', border: 'rgba(59,130,246,0.4)', text: '#60a5fa', solid: '#3b82f6' },
  { bg: 'rgba(168,85,247,0.12)', border: 'rgba(168,85,247,0.4)', text: '#c084fc', solid: '#a855f7' },
  { bg: 'rgba(249,115,22,0.12)', border: 'rgba(249,115,22,0.4)', text: '#fb923c', solid: '#f97316' },
  { bg: 'rgba(236,72,153,0.12)', border: 'rgba(236,72,153,0.4)', text: '#f472b6', solid: '#ec4899' },
  { bg: 'rgba(20,184,166,0.12)', border: 'rgba(20,184,166,0.4)', text: '#2dd4bf', solid: '#14b8a6' },
  { bg: 'rgba(234,179,8,0.12)', border: 'rgba(234,179,8,0.4)', text: '#facc15', solid: '#eab308' },
  { bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.4)', text: '#34d399', solid: '#10b981' },
];

const HomeEspacios = () => {
  const [reservas, setReservas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [weekOffset, setWeekOffset] = useState(0);
  const [selectedCellInfo, setSelectedCellInfo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [areas, setAreas] = useState([]);
  const [espacios, setEspacios] = useState([]);
  const [filterArea, setFilterArea] = useState('');
  const [filterSpace, setFilterSpace] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [viewMode, setViewMode] = useState('week'); // 'week' | 'day'
  const [selectedDayIdx, setSelectedDayIdx] = useState(null);
  const [hoveredCell, setHoveredCell] = useState(null);
  const tableRef = useRef(null);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user_espacios') || '{}');
  const initial = user.nombre ? user.nombre.charAt(0).toUpperCase() : 'A';
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;

  const timeSlots = ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00'];
  const dayLabels = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];

  useEffect(() => {
    if (!localStorage.getItem('user_espacios')) { navigate('/espacios/login'); return; }
    fetchReservas(); fetchFilters();
  }, [weekOffset]);

  // Set selectedDayIdx to today on mount
  useEffect(() => {
    const today = new Date();
    const d = today.getDay();
    setSelectedDayIdx(d === 0 ? 6 : d - 1);
  }, []);

  const fetchFilters = async () => {
    try {
      const [areasResp, spacesResp] = await Promise.all([
        fetch(`${apiBase}/api/espacios/areas`, { credentials: 'include' }),
        fetch(`${apiBase}/api/espacios/espacios`, { credentials: 'include' })
      ]);
      const areasData = await areasResp.json();
      const spacesData = await spacesResp.json();
      setAreas(Array.isArray(areasData) ? areasData : []);
      setEspacios(Array.isArray(spacesData) ? spacesData : []);
    } catch (err) { console.error('Error fetching filters:', err); }
  };

  const fetchReservas = async () => {
    try {
      const resp = await fetch(`${apiBase}/api/espacios/reservas`, { credentials: 'include', cache: 'no-store' });
      if (resp.status === 401) { localStorage.removeItem('user_espacios'); navigate('/espacios/login'); return; }
      if (!resp.ok) throw new Error('Error');
      const data = await resp.json();
      setReservas(Array.isArray(data) ? data : []);
    } catch (err) { console.error('Error fetching reservas:', err); }
    finally { setLoading(false); }
  };

  const getLocalDateString = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  };

  const today = new Date();
  const currentDay = today.getDay();
  const daysToMonday = currentDay === 0 ? 6 : currentDay - 1;
  const monday = new Date(today);
  monday.setDate(today.getDate() - daysToMonday + (weekOffset * 7));
  const weekDays = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday); d.setDate(monday.getDate() + i); return getLocalDateString(d);
  });
  const todayStr = getLocalDateString(new Date());

  // Color por área
  const areaColorMap = {};
  areas.forEach((a, i) => { areaColorMap[a.id] = AREA_COLORS[i % AREA_COLORS.length]; });

  const getColorForReserva = (r) => {
    const esp = espacios.find(e => e.id === r.espacio_id);
    if (esp && areaColorMap[esp.area_id]) return areaColorMap[esp.area_id];
    return AREA_COLORS[0];
  };

  const getReservasForCell = (date, time) => {
    const slotHour = parseInt(time.split(':')[0]);
    return reservas.filter(r => {
      const rDate = new Date(r.fecha).toISOString().split('T')[0];
      const startHour = parseInt(r.hora_inicio.split(':')[0]);
      const endHour = parseInt(r.hora_fin.split(':')[0]);
      const matchTime = slotHour >= startHour && slotHour < endHour;
      const matchSpace = filterSpace ? r.espacio_id === filterSpace : true;
      const espacio = espacios.find(e => e.id === r.espacio_id);
      const matchArea = filterArea ? espacio?.area_id === filterArea : true;
      const matchSearch = searchTerm ? r.responsable.toLowerCase().includes(searchTerm.toLowerCase()) || (r.motivo && r.motivo.toLowerCase().includes(searchTerm.toLowerCase())) : true;
      return rDate === date && matchTime && matchSpace && matchArea && matchSearch;
    });
  };

  const handleCellClick = (date, time, cellRes) => {
    if (cellRes.length > 0) { setSelectedCellInfo({ date, time, reservas: cellRes }); setShowModal(true); }
    else { navigate(`/espacios/reservas?date=${date}&time=${time}`); }
  };



  // Export
  const handleExport = () => {
    const weekStart = new Date(weekDays[0] + 'T00:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'long' });
    const weekEnd = new Date(weekDays[6] + 'T00:00:00').toLocaleDateString('es-CL', { day: 'numeric', month: 'long', year: 'numeric' });

    let html = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
      <head><meta charset="UTF-8">
      <style>
        body { font-family: Calibri, Arial, sans-serif; }
        .titulo { font-size: 18px; font-weight: bold; color: #0f172a; }
        .subtitulo { font-size: 12px; color: #64748b; }
        .header { background: #0f172a; color: #ffffff; font-weight: bold; text-align: center; padding: 8px; font-size: 11px; }
        .hora { background: #f1f5f9; font-weight: bold; text-align: center; color: #334155; font-size: 11px; width: 60px; }
        .celda { border: 1px solid #e2e8f0; padding: 6px; font-size: 10px; vertical-align: top; }
        .ocupado { font-size: 10px; }
        .espacio { font-weight: bold; color: #0f172a; }
        .detalle { color: #64748b; font-size: 9px; }
        .resumen { background: #f8fafc; font-weight: bold; font-size: 11px; }
      </style></head><body>
      <table>
        <tr><td colspan="8" class="titulo">📋 Agenda Semanal de Espacios</td></tr>
        <tr><td colspan="8" class="subtitulo">Semana del ${weekStart} al ${weekEnd}</td></tr>
        <tr><td colspan="8" class="subtitulo">Generado: ${new Date().toLocaleString('es-CL')}</td></tr>
        <tr><td colspan="8"></td></tr>
        <tr>
          <td class="header">Hora</td>`;

    dayLabels.forEach((day, i) => {
      const dateNum = new Date(weekDays[i] + 'T00:00:00').getDate();
      const isToday = weekDays[i] === todayStr;
      html += `<td class="header" style="${isToday ? 'background:#10b981;' : ''}">${day} ${dateNum}</td>`;
    });
    html += '</tr>';

    // Contadores por día
    const dayCounts = weekDays.map(() => 0);

    timeSlots.forEach(slot => {
      html += `<tr><td class="celda hora">${slot}</td>`;
      weekDays.forEach((date, di) => {
        const cellRes = getReservasForCell(date, slot);
        if (cellRes.length > 0) {
          dayCounts[di] += cellRes.length;
          const content = cellRes.map(r => {
            const esp = espacios.find(e => e.id === r.espacio_id);
            const area = esp ? areas.find(a => a.id === esp.area_id) : null;
            return `<span class="espacio">${r.espacio_nombre}</span><br/>` +
              `<span class="detalle">${r.hora_inicio.substring(0,5)}-${r.hora_fin.substring(0,5)} · ${r.responsable}</span>` +
              (r.motivo ? `<br/><span class="detalle">Motivo: ${r.motivo}</span>` : '') +
              (area ? `<br/><span class="detalle">Área: ${area.nombre}</span>` : '');
          }).join('<br/><br/>');
          html += `<td class="celda ocupado" style="background:#f0fdf4;">${content}</td>`;
        } else {
          html += '<td class="celda"></td>';
        }
      });
      html += '</tr>';
    });

    // Fila resumen
    html += '<tr><td class="celda resumen">Total</td>';
    dayCounts.forEach(c => {
      html += `<td class="celda resumen" style="text-align:center;">${c} reserva${c !== 1 ? 's' : ''}</td>`;
    });
    html += '</tr>';

    // Listado detallado
    html += `
      <tr><td colspan="8"></td></tr>
      <tr><td colspan="8" class="titulo">📝 Detalle de Reservas de la Semana</td></tr>
      <tr>
        <td class="header">Fecha</td>
        <td class="header">Espacio</td>
        <td class="header">Área</td>
        <td class="header">Inicio</td>
        <td class="header">Fin</td>
        <td class="header">Responsable</td>
        <td class="header">RUT</td>
        <td class="header">Motivo</td>
      </tr>`;

    const weekReservas = reservas.filter(r => {
      const rDate = new Date(r.fecha).toISOString().split('T')[0];
      return weekDays.includes(rDate);
    }).sort((a, b) => a.fecha.localeCompare(b.fecha) || a.hora_inicio.localeCompare(b.hora_inicio));

    weekReservas.forEach(r => {
      const rDate = new Date(r.fecha).toISOString().split('T')[0];
      const esp = espacios.find(e => e.id === r.espacio_id);
      const area = esp ? areas.find(a => a.id === esp.area_id) : null;
      const fechaStr = new Date(r.fecha).toLocaleDateString('es-CL', { weekday: 'short', day: 'numeric', month: 'short' });
      html += `<tr>
        <td class="celda">${fechaStr}</td>
        <td class="celda espacio">${r.espacio_nombre || ''}</td>
        <td class="celda">${area ? area.nombre : ''}</td>
        <td class="celda" style="text-align:center;">${r.hora_inicio.substring(0,5)}</td>
        <td class="celda" style="text-align:center;">${r.hora_fin.substring(0,5)}</td>
        <td class="celda">${r.responsable || ''}</td>
        <td class="celda">${r.rut || ''}</td>
        <td class="celda">${r.motivo || ''}</td>
      </tr>`;
    });

    if (weekReservas.length === 0) {
      html += '<tr><td colspan="8" class="celda detalle" style="text-align:center;">Sin reservas esta semana</td></tr>';
    }

    html += '</table></body></html>';

    const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Agenda_Espacios_${weekDays[0]}_a_${weekDays[6]}.xls`;
    a.click();
    URL.revokeObjectURL(url);
  };


  // Vista día
  const dayColumns = viewMode === 'day' && selectedDayIdx !== null ? [selectedDayIdx] : [0,1,2,3,4,5,6];

  if (loading) return (
    <div className="App-layout-espacios"><SidebarEspacios />
      <main className="App-main-espacios"><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><div className="spinner"></div></div></main>
    </div>
  );

  return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      <main className="App-main-espacios">
        <header className="view-page-header">
          <div className="view-title-block">
            <h2>Panel de Control</h2>
            <p>Control estratégico de infraestructura municipal</p>
          </div>
          <div className="header-actions">
            <button className="btn-high-end btn-high-end-primary" onClick={() => navigate('/espacios/reservas')}>
              <i className="fa-solid fa-calendar-plus"></i> Nueva Reserva
            </button>
            <div className="user-pill-dark">
              <div className="avatar">{initial}</div>
              <span>{user.nombre || 'Administrador'}</span>
            </div>
          </div>
        </header>

        <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '16px', marginBottom: '24px' }}>
          <div className="stat-card-premium" style={{ padding: '12px 20px' }}>
            <div className="stat-icon-box" style={{ width: '36px', height: '36px', fontSize: '14px' }}><i className="fa-solid fa-chart-simple"></i></div>
            <div className="stat-content">
              <p className="label" style={{ fontSize: '10px' }}>Reservas Totales</p>
              <h4 className="value" style={{ fontSize: '18px' }}>{reservas.length}</h4>
            </div>
          </div>
          <div className="stat-card-premium" style={{ padding: '12px 20px' }}>
            <div className="stat-icon-box" style={{ width: '36px', height: '36px', fontSize: '14px', color: '#3b82f6', background: 'rgba(59, 130, 246, 0.1)' }}><i className="fa-solid fa-calendar-check"></i></div>
            <div className="stat-content">
              <p className="label" style={{ fontSize: '10px' }}>Eventos Hoy</p>
              <h4 className="value" style={{ fontSize: '18px' }}>{reservas.filter(r => new Date(r.fecha).toISOString().split('T')[0] === todayStr).length}</h4>
            </div>
          </div>
        </section>

        <div className="calendar-glass-card" style={{ marginBottom: '32px' }}>
          {/* ── Fila 1: Título + Navegación ── */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <h3 style={{ fontSize: '20px', fontWeight: '800', margin: 0 }}>Agenda {viewMode === 'week' ? 'Semanal' : 'Diaria'}</h3>
              <div style={{ display: 'flex', background: 'rgba(0,0,0,0.3)', borderRadius: '8px', overflow: 'hidden', border: '1px solid var(--esp-border)' }}>
                <button type="button" style={{ background: viewMode === 'day' ? 'var(--esp-primary)' : 'transparent', color: 'white', padding: '5px 12px', fontSize: '11px', fontWeight: '700', border: 'none', cursor: 'pointer' }}
                  onClick={() => setViewMode('day')}><i className="fa-solid fa-calendar-day" style={{ marginRight: '4px' }}></i>Día</button>
                <button type="button" style={{ background: viewMode === 'week' ? 'var(--esp-primary)' : 'transparent', color: 'white', padding: '5px 12px', fontSize: '11px', fontWeight: '700', border: 'none', cursor: 'pointer' }}
                  onClick={() => setViewMode('week')}><i className="fa-solid fa-calendar-week" style={{ marginRight: '4px' }}></i>Semana</button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button type="button" style={{ background: 'rgba(0,0,0,0.25)', color: 'var(--esp-text-muted)', padding: '6px 10px', border: '1px solid var(--esp-border)', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }} onClick={() => setWeekOffset(prev => prev - 1)}><i className="fa-solid fa-chevron-left"></i></button>
              <button type="button" style={{ background: 'rgba(0,0,0,0.25)', color: 'white', padding: '6px 16px', border: '1px solid var(--esp-border)', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }} onClick={() => setWeekOffset(0)}>Hoy</button>
              <button type="button" style={{ background: 'rgba(0,0,0,0.25)', color: 'var(--esp-text-muted)', padding: '6px 10px', border: '1px solid var(--esp-border)', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }} onClick={() => setWeekOffset(prev => prev + 1)}><i className="fa-solid fa-chevron-right"></i></button>
              <div style={{ width: '1px', height: '20px', background: 'var(--esp-border)', margin: '0 4px' }}></div>
              <button type="button" style={{ background: 'rgba(0,0,0,0.25)', color: 'var(--esp-text-muted)', padding: '6px 14px', border: '1px solid var(--esp-border)', borderRadius: '8px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }} onClick={handleExport}><i className="fa-solid fa-file-excel" style={{ marginRight: '5px' }}></i>Excel</button>
            </div>
          </div>

          {/* ── Fila 2: Filtros + Leyenda ── */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '16px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ position: 'relative' }}>
                <i className="fa-solid fa-magnifying-glass" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '10px', color: 'var(--esp-text-muted)' }}></i>
                <input type="text" placeholder="Buscar responsable..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
                  style={{ background: 'rgba(0,0,0,0.25)', border: '1px solid var(--esp-border)', color: 'white', borderRadius: '8px', padding: '7px 12px 7px 28px', fontSize: '12px', outline: 'none', width: '180px' }} />
              </div>
              <select value={filterArea} onChange={e => { setFilterArea(e.target.value); setFilterSpace(''); }}
                style={{ background: 'rgba(0,0,0,0.25)', border: '1px solid var(--esp-border)', color: 'white', borderRadius: '8px', padding: '7px 12px', fontSize: '12px', outline: 'none' }}>
                <option value="">Todas las Áreas</option>
                {areas.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
              </select>
              <select value={filterSpace} onChange={e => setFilterSpace(e.target.value)}
                style={{ background: 'rgba(0,0,0,0.25)', border: '1px solid var(--esp-border)', color: 'white', borderRadius: '8px', padding: '7px 12px', fontSize: '12px', outline: 'none' }}>
                <option value="">Todos los Espacios</option>
                {espacios.filter(e => !filterArea || e.area_id === filterArea).map(e => (
                  <option key={e.id} value={e.id}>{e.nombre}</option>
                ))}
              </select>
            </div>
            {areas.length > 0 && (
              <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                {areas.map((a, i) => {
                  const c = AREA_COLORS[i % AREA_COLORS.length];
                  return (
                    <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '10px', fontWeight: '600', color: 'var(--esp-text-muted)' }}>
                      <div style={{ width: '8px', height: '8px', borderRadius: '2px', background: c.solid }}></div>
                      {a.nombre}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* ── Selector de Día (solo en vista día) ── */}
          {viewMode === 'day' && (
            <div style={{ display: 'flex', gap: '6px', marginBottom: '16px' }}>
              {dayLabels.map((day, idx) => {
                const isToday = weekDays[idx] === todayStr;
                const isActive = selectedDayIdx === idx;
                return (
                  <button key={idx} type="button" onClick={() => setSelectedDayIdx(idx)}
                    style={{ flex: 1, padding: '10px 0', borderRadius: '10px',
                      border: isActive ? '1.5px solid var(--esp-primary)' : '1px solid var(--esp-border)',
                      background: isActive ? 'rgba(16,185,129,0.08)' : 'rgba(0,0,0,0.2)',
                      color: isActive ? 'var(--esp-primary)' : isToday ? 'var(--esp-primary)' : 'var(--esp-text-muted)',
                      fontWeight: isActive ? '800' : '600', fontSize: '12px', cursor: 'pointer', transition: 'all 0.2s', textAlign: 'center' }}>
                    {day}
                    <span style={{ display: 'block', fontSize: '16px', fontWeight: '800', marginTop: '2px', color: isActive ? 'white' : 'inherit' }}>{new Date(weekDays[idx] + 'T00:00:00').getDate()}</span>
                  </button>
                );
              })}
            </div>
          )}

          {/* ── Tabla/Horario ── */}
          <div className="calendar-table-wrapper" ref={tableRef}>
            <table className="table-premium">
              <thead>
                <tr>
                  <th className="hour-cell"></th>
                  {dayColumns.map(idx => {
                    const isToday = weekDays[idx] === todayStr;
                    return (
                      <th key={idx} className={isToday ? 'today-header' : ''}>
                        {dayLabels[idx]}
                        <span style={{ opacity: 0.5, fontSize: '10px', display: 'block', marginTop: '2px' }}>{new Date(weekDays[idx] + 'T00:00:00').getDate()}</span>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {timeSlots.map(slot => (
                  <tr key={slot}>
                    <td className="hour-cell">{slot}</td>
                    {dayColumns.map(idx => {
                      const date = weekDays[idx];
                      const cellRes = getReservasForCell(date, slot);
                      const count = cellRes.length;
                      const cellKey = `${date}-${slot}`;
                      const isHovered = hoveredCell === cellKey;
                      const color = count === 1 ? getColorForReserva(cellRes[0]) : count > 1 ? { bg: 'rgba(255,255,255,0.06)', border: 'rgba(255,255,255,0.1)', text: 'white', solid: '#6b7280' } : null;

                      return (
                        <td key={date} className={count > 0 ? 'occupied' : 'available-cell'}
                          style={{ position: 'relative' }}
                          onClick={() => handleCellClick(date, slot, cellRes)}
                          onMouseEnter={() => count > 0 && setHoveredCell(cellKey)}
                          onMouseLeave={() => setHoveredCell(null)}>
                          {count > 0 && (
                            <div className="reserva-tag" style={{ background: color.bg, color: color.text, border: `1px solid ${color.border}` }}>
                              {count === 1 ? (viewMode === 'day' ? `${cellRes[0].espacio_nombre} — ${cellRes[0].responsable}` : cellRes[0].espacio_nombre.split(' ')[0]) : `Múltiple (${count})`}
                            </div>
                          )}
                          {isHovered && count > 0 && (
                            <div style={{
                              position: 'absolute', bottom: 'calc(100% + 8px)', left: '50%', transform: 'translateX(-50%)',
                              background: '#0c1222', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px',
                              padding: '10px 14px', zIndex: 50, minWidth: '210px', maxWidth: '280px',
                              boxShadow: '0 12px 40px rgba(0,0,0,0.6)', pointerEvents: 'none'
                            }}>
                              {cellRes.slice(0, 3).map((r, ri) => {
                                const rc = getColorForReserva(r);
                                return (
                                  <div key={r.id} style={{ marginBottom: ri < Math.min(count,3)-1 ? '6px' : 0, paddingBottom: ri < Math.min(count,3)-1 ? '6px' : 0, borderBottom: ri < Math.min(count,3)-1 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
                                    <div style={{ fontSize: '11px', fontWeight: '800', color: rc.text }}>{r.espacio_nombre}</div>
                                    <div style={{ fontSize: '10px', color: 'var(--esp-text-muted)', marginTop: '2px' }}>
                                      <i className="fa-regular fa-clock" style={{ marginRight: '4px', fontSize: '9px' }}></i>
                                      {r.hora_inicio.substring(0,5)} – {r.hora_fin.substring(0,5)} · {r.responsable}
                                    </div>
                                  </div>
                                );
                              })}
                              {count > 3 && <div style={{ fontSize: '10px', color: 'var(--esp-text-muted)', marginTop: '4px' }}>+{count - 3} más...</div>}
                              <div style={{ position: 'absolute', bottom: '-5px', left: '50%', transform: 'translateX(-50%) rotate(45deg)', width: '10px', height: '10px', background: '#0c1222', borderRight: '1px solid rgba(255,255,255,0.08)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}></div>
                            </div>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>


        <section className="calendar-glass-card" style={{ padding: '24px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: '800', marginBottom: '20px' }}>Próximos Eventos</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
            {reservas.slice(0, 8).map(r => {
              const rc = getColorForReserva(r);
              return (
                <div key={r.id} style={{ display: 'flex', gap: '12px', alignItems: 'center', padding: '16px', borderRadius: '12px', background: 'rgba(255,255,255,0.02)', border: '1px solid var(--esp-border)', borderLeft: `3px solid ${rc.solid}` }}>
                  <div style={{ overflow: 'hidden' }}>
                    <p style={{ fontSize: '14px', fontWeight: '700', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.espacio_nombre}</p>
                    <p style={{ fontSize: '12px', color: 'var(--esp-text-muted)', margin: '4px 0 0' }}>
                      <i className="fa-regular fa-clock" style={{ marginRight: '6px' }}></i>
                      {r.hora_inicio.substring(0,5)} • {r.responsable}
                    </p>
                  </div>
                </div>
              );
            })}
            {reservas.length === 0 && <p style={{ fontSize: '13px', color: 'var(--esp-text-muted)', textAlign: 'center', gridColumn: '1 / -1' }}>No hay eventos próximos.</p>}
          </div>
        </section>

        {showModal && selectedCellInfo && (
          <div className="modal-overlay" onClick={() => setShowModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div className="calendar-glass-card" style={{ maxWidth: '440px', width: '90%', padding: '32px' }} onClick={e => e.stopPropagation()}>
              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ fontSize: '22px', fontWeight: '800' }}>Detalle de Agenda</h3>
                <p style={{ fontSize: '14px', color: 'var(--esp-text-muted)' }}>{selectedCellInfo.date} • {selectedCellInfo.time}</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', maxHeight: '40vh', overflowY: 'auto' }}>
                {selectedCellInfo.reservas.map(r => {
                  const rc = getColorForReserva(r);
                  return (
                    <div key={r.id} style={{ padding: '16px', border: `1px solid ${rc.border}`, borderLeft: `3px solid ${rc.solid}`, borderRadius: '12px', background: 'var(--esp-surface-light)' }}>
                      <h4 style={{ fontSize: '15px', color: rc.text, fontWeight: '800', marginBottom: '8px' }}>{r.espacio_nombre}</h4>
                      <p style={{ fontSize: '13px', margin: '4px 0' }}><strong>Responsable:</strong> {r.responsable}</p>
                      <p style={{ fontSize: '13px', opacity: 0.8 }}><strong>Motivo:</strong> {r.motivo || 'N/A'}</p>
                    </div>
                  );
                })}
              </div>
              <button className="btn-high-end btn-high-end-primary" style={{ marginTop: '24px', width: '100%', justifyContent: 'center' }} onClick={() => setShowModal(false)}>
                Cerrar Detalle
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default HomeEspacios;
